<template>
  <div class="seat-map-footer">
    <!-- Additional price paid or the selected seats -->
    <div v-if="totalAdditionalPrice !== '' && currencySymbol" class="font-size-16px">
      Totale: <span class="semibold">{{ totalAdditionalPrice }} {{ currencySymbol }}</span>
    </div>

    <!-- Flight button controls -->
    <div class="seat-map-footer-actions">
      <vb-button
        v-if="isPreviousActionVisible"
        class="font-weight-bold d-flex align-items-center justify-content-center"
        :vb_options="{ variant: 'outline-info', disabled: isPreviousActionDisabled }"
        role="button"
        @click="previousSegmentAction"
      >
        Volo precedente
      </vb-button>
      <span id="seat-map-next-action" class="d-inline-block">
        <vb-button
          class="font-weight-bold d-flex align-items-center justify-content-center"
          :vb_options="{ variant: 'info', disabled: isNextSegmentActionDisabled }"
          role="button"
          @click="handleNextSegmentAction"
        >
          <span>
            {{ nextSegmentActionLabel }}
          </span>
        </vb-button>
        <b-popover
          v-if="mustSelectSeats && isNextSegmentActionDisabled"
          target="seat-map-next-action"
          variant="primary"
          triggers="hover"
          placement="top"
        >
          Seleziona tutti i posti di ogni passeggero prima di continuare.
        </b-popover>
      </span>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '@liveflight/utilities';
import { calculate_total_seats_price } from '@liveflight/utilities/seat-map';

export default {
  name: 'seat-map-footer',
  props: {
    mustSelectSeats: {
      type: Boolean,
      default: false,
    },
    isPreviousActionVisible: Boolean,
    isPreviousActionDisabled: Boolean,
    previousSegmentAction: Function,

    nextSegmentActionLabel: String,
    isNextSegmentActionDisabled: Boolean,
    handleNextSegmentAction: Function,

    parsedSelections: Object,
    currencySymbol: {
      type: String,
      default: '',
    },
  },
  methods: {
    formatPrice,
  },
  computed: {
    totalAdditionalPrice() {
      const total = calculate_total_seats_price(this.parsedSelections);
      if (total <= 0) {
        return '';
      }
      return this.formatPrice(total);
    },
  },
};
</script>

<style lang="scss">
.seat-map-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  div:last-of-type {
    margin-left: auto;
  }

  @media screen and (max-width: $seat-map-mobile-breakpoint) {
    flex-wrap: wrap;
    row-gap: 10px;
  }
}
.seat-map-footer-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;

  @media screen and (max-width: $seat-map-mobile-breakpoint) {
    width: 100%;

    > .vb-btn,
    > #seat-map-next-action {
      flex: 0 0 calc(50% - 5px);
      max-width: calc(50% - 5px);
      min-width: 0;
    }

    > .vb-btn:only-child,
    > #seat-map-next-action:only-child {
      flex-basis: 100%;
      max-width: 100%;
    }

    .vb-btn {
      width: 100%;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
}
</style>
